import RequestFormModelBase from '../_generated/modelBases/request-form-model-base';

export default class RequestFormModel extends RequestFormModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
